import axios from 'axios';

const baseURL = process.env.VUE_APP_AUTH_URL;

export function authorize(data) {
    return axios.post(baseURL + '/authorize', null, {
        auth: {
            username: data.username,
            password: data.password
        },
        headers: {
            'X-OTP': `Authenticator ${data.twoFactorCode}`
        }
    });
}

export function setAuthorizationHeader(data) {
    axios.defaults.headers.common['Authorization'] = `${data.tokenType} ${data.accessToken}`;
}

export function deleteAuthorizationHeader() {
    delete axios.defaults.headers.common['Authorization'];
}

export function updatePassword(data) {
    return axios.patch(baseURL + '/change-password', data);
}

export function resetPasswordToken(data) {
    return axios.post(baseURL + '/reset-password-token', data);
}

export function resetPassword(data) {
    return axios.post(baseURL + '/reset-password', data);
}

export function reset2FA(data) {
    return axios.put(baseURL + '/reset-2fa', data);
}

export function impersonatePartner(email) {
    return axios.post(baseURL + '/impersonate', { username: email });
}
